// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__Dpsgu","Question":"ActiveQuiz_Question__18iOr"};